import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Card, Col, Empty, Flex, Form, Input, InputNumber, message, Row, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useParams } from "react-router";
import { useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import RenderIf from "../../../components/RenderIf";
import { ratePerParameterService } from "../../../services/rate-per-parameter.service";

const idrFormatter = {
  formatter: value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
  parser: value => value.replace(/\Rp\s?|(\.)|[^\d]/g, '')
}

export default function RatePerParameterForm(){

  const { id } = useParams()

  const [form] = useForm()
  const navigate = useNavigate()

  const { data: ratePerParameter  } = useQuery({
    queryKey: ['detailRatePerParameter', id],
    queryFn: () => ratePerParameterService.getById(id),
    enabled: !!id
  })

  useEffect(() => {
    if(id){
      form.setFieldsValue(ratePerParameter?.data)
    }

  }, [ratePerParameter, form, id])

  const updateMutation = useMutation({
    mutationFn: (data) => ratePerParameterService.update(data),
    onSuccess: () => {
      message.success('Data berhasil diubah');
      form.resetFields();
      navigate('/lab-service/rate-per-parameter')
    },
    onError: (error) => {
      console.log(error)
      message.error('Terjadi Kesalahan');
    }
  })

  const handleSubmit = (val) => updateMutation.mutate(val)

  return (
    <>
      <Card
        title={ratePerParameter?.data?.name}
        actions={[
          <Flex key={1} justify="end" style={{ paddingRight: 24 }} gap={16} >
            <Button onClick={() => navigate('/lab-service/rate-per-parameter')} variant="outlined" color="primary" >
              Batal
            </Button>
            <Button 
              variant="solid" 
              color="primary" 
              onClick={() => form.submit()}
            >
              Simpan
            </Button>
          </Flex>
        ]}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
          requiredMark={false}
        >
          <Form.Item hidden name={'id'} >
            <Input/>
          </Form.Item>
          <Form.Item hidden name={'name'} >
            <Input/>
          </Form.Item>
          <Form.List 
            name='parameter' 
            rules={[
              {
                validator: async (_, fields) => {
                  if (!fields || fields.length < 1) {
                    return Promise.reject(new Error('Parameter minimal 1'));
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                <RenderIf when={fields.length == 0} >
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Belum ada parameter" />
                </RenderIf>
                {fields.map((field,index) => (
                  <Flex key={index} style={{ width: '100%' }} gap={14} >
                    <Typography.Text style={{ width: 20, fontSize: 14, marginTop: 5, alignSelf: index == 0 ? 'center' : 'flex-start' }} >
                      {index+1}
                    </Typography.Text>
                    <Row gutter={[20]} style={{ width: '100%' }} >
                      <Col span={12} >
                        <Form.Item
                          label={index == 0 ? "Parameter" : null}
                          name={[field.name, 'parameter']}
                          style={{ width: '100%' }}
                          rules={[
                            {
                              required: true,
                              message: 'Parameter harus diisi',
                            },
                          ]}
                        >
                          <Input placeholder="parameter" style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                      <Col span={12} >
                        <Form.Item
                          label={index == 0 ? "Harga" : ""}
                          name={[field.name, 'price']}
                          style={{ width: '100%' }}
                          
                          rules={[
                            {
                              required: true,
                              message: 'Harga harus diisi',
                            },
                          ]}
                        >
                          <InputNumber 
                            style={{ width: '100%' }}
                            {...idrFormatter}
                            placeholder="Harga"
                            prefix="Rp "
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Button
                      style={{ alignSelf: index == 0 ? 'center' : 'flex-start' }}
                      variant="filled"
                      color="danger"
                      onClick={() => remove(field.name)}
                      icon={
                        <Icon
                          icon='solar:trash-bin-trash-bold-duotone'
                          width={21}
                          height={21}
                          style={{ marginBottom: -2 }}
                        />
                      }
                    />
                  </Flex>
                ))}
                <Flex justify={ fields.length == 0 ? "center" : "end"} >
                  <Button variant="filled" color="primary" onClick={() => add()} >
                    Tambah Parameter
                  </Button>
                </Flex>
                <Form.Item>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Card>
    </>
  )
}